<template>
<div>
  <BModal
    id="user-destroy-modal"
    ref="user-destroy-modal"
    aria-labelledby="user-destroy-modal"
    modal-class="modal-no-header-no-footer"
    hide-footer="hide-footer"
    hide-header="hide-header"
    centered
  >
    <template slot="default">
      <button
        class="close"
        type="button"
        aria-label="Close"
        @click="$refs['user-destroy-modal'].hide()"
      >
        <span aria-hidden="true">×</span>
      </button>
      <h4 class="modal-title align-items-center text-center pt-20px mb-4">
        {{ __('Remover acesso') }}
      </h4>
      <p class="h6 modal-subtitle align-items-center text-center mt-0 mb-4">
        {{ __('Usuário') }}: {{ user.name }}
      </p>
      <form
        id="form-filter"
        class="align-items-center text-center"
        v-on:submit="handleUserDestroyModalCompleted"
      >
        <span class="modal-text-info">
          Caso queira, você pode transferir os leads e atividades agendadas para
          outro(s) usuário(s).
        </span>
        <div class="form-group d-flex justify-content-center px-5 pt-4">
          <div class="form-wrapper">
            <div class="radio-input-group">
              <input
              id="none"
              v-model="leads.option"
              type="radio"
              name="distribute_leads"
              value="none"
            />
            <label class="radio-button-label" for="none">Não transferir</label>
            <br />
            </div>
            <div class="radio-input-group">
              <input
              id="individual"
              v-model="leads.option"
              type="radio"
              name="distribute_leads"
              value="individual"
            />
            <label class="radio-button-label" for="individual">Para um usuário</label>
            <br />
            </div>
            <div class="radio-input-group">
              <input
              id="multiple"
              v-model="leads.option"
              type="radio"
              name="distribute_leads"
              value="multiple"
            />
            <label class="radio-button-label" for="multiple">Para vários usuários</label>
            </div>
            </div>
        </div>
        <div v-if="leads.option == 'individual'" class="form-group px-5">
          <span class="modal-text-info">
            {{ __('Atribuir todos os leads/atividades para o usuário:') }}
          </span>
          <select v-model="leads.value" class="form-control mt-4" name="next_user_id" required>
            <option disabled selected value="">Selecione uma opção</option>
            <option v-for="u in parsedUsers" :key="u.id" :value="u.id">
              {{ u.name }}
            </option>
          </select>
        </div>
        <div v-if="leads.option == 'multiple'" class="form-group px-5">
          <span>
            {{ __('Distribuir de forma igualitária para o grupo:') }}
          </span>
          <select v-model="leads.value" class="form-control mt-4" name="role_id">
            <option value="all">
              {{ __('Todos os usuários') }}
            </option>
            <option v-for="r in filteredRoles" :key="r.id" :value="r.id">
              {{ r.name }}
            </option>
          </select>
        </div>
        <div class="form-group text-center mt-30px">
          <button
            class="btn btn-primary align-items-center"
            variant="primary"
            type="submit"
          >
            <span>{{ __('Continuar') }}</span>
          </button>
          <div class="cancel-modal-button mt-3">
            <a href="#" data-dismiss="modal" @click="hideUserDestroyModal()">
              {{ __('Cancelar') }}
            </a>
          </div>
        </div>
      </form>
    </template>
  </BModal>
  <BModal
    id="distribute-user-deals-modal"
    ref="distribute-user-deals-modal"
    aria-labelledby="distribute-user-deals-modal"
    modal-class="modal-no-header-no-footer"
    hide-footer="hide-footer"
    hide-header="hide-header"
    centered
  >
    <template slot="default">
      <button
        class="close"
        type="button"
        aria-label="Close"
        @click="$refs['distribute-user-deals-modal'].hide()"
      >
        <span aria-hidden="true">×</span>
      </button>
      <h4 class="modal-title align-items-center text-center pt-20px mb-4">
        {{ __('Transferir negócios ativos') }}
      </h4>
      <p class="h6 modal-subtitle align-items-center text-center mt-0 mb-4">
        {{ __('Usuário') }}: {{ user.name }}
      </p>
      <form
        class="align-items-center text-center"
        v-on:submit="removeUser"
      >
        <span class="modal-text-info">
          Este usuário possuía negócios em andamento.
          <br>
          Para quem deseja transferir estes negócios?
        </span>

        <div class="form-group d-flex px-48px pt-24px mb-0">
          <div class="form-wrapper">
            <div class="radio-input-group mb-4">
              <input
              id="individual"
              v-model="deals.option"
              type="radio"
              name="distribute_deals"
              value="individual"
            />
            <label class="radio-button-label" for="individual">Para um usuário</label>
            </div>
            <div class="radio-input-group mb-0">
              <input
              id="multiple"
              v-model="deals.option"
              type="radio"
              name="distribute_deals"
              value="multiple"
            />
            <label class="radio-button-label" for="multiple">Para vários usuários</label>
            <br />
            </div>
            </div>
        </div>
        <div v-if="deals.option == 'individual'" class="form-group px-5 d-flex flex-column align-items-center justify-content-center">
          <p class="modal-distribution-info mt-4 mb-4">
            Atribuir todos os negócios a um usuário:
          </p>

          <select
            v-model="deals.value"
            :class="{ 'font-gray-light': !deals.value }"
            class="form-control modal-input"
            name="next_user_id"
          >
            <option value="">
              {{ __('Selecione o usuário') }}
            </option>
            <option v-for="u in parsedUsers" :key="u.id" :value="u.id">
              {{ u.name }}
            </option>
          </select>
        </div>
        <div v-else-if="deals.option == 'multiple'" class="form-group px-5 d-flex flex-column align-items-center justify-content-center">
          <p class="modal-distribution-info mt-4 mb-4">
            Distribuir aleatoriamente todos os negócios a um grupo:
          </p>

          <select
            v-model="deals.value"
            :class="{ 'font-gray-light': !deals.value }"
            class="form-control modal-input"
            name="role_id"
          >
            <option value="all">
              {{ __('Todos os usuários') }}
            </option>
            <option v-for="r in filteredRoles" :key="r.id" :value="r.id">
              {{ r.name }}
            </option>
          </select>
        </div>
        <div class="form-group text-center mt-40px">
          <button
            class="btn btn-primary align-items-center"
            variant="primary"
            type="submit"
          >
            <span>{{ __('Continuar') }}</span>
          </button>
          <div class="cancel-modal-button mt-3">
            <a href="#" data-dismiss="modal" @click="hideDistributeUserDealsModal()">
              {{ __('Cancelar') }}
            </a>
          </div>
        </div>
      </form>
    </template>
  </BModal>
</div>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import { Confirm } from '../../services/Confirm';

export default {
  components: {
    BModal,
  },

  props: {
    users: null,
    token: null,
  },

  data() {
    return {
      user: {},
      roles: [],
      leads: {
        option: 'none',
        value: ''
      },
      deals: {
        option: 'individual',
        value: ''
      }
    };
  },

  computed: {
    parsedUsers() {
      const users =
        typeof this.users === 'string' ? JSON.parse(this.users) : this.users;
      return users.filter((user) => user.id !== this.user.id);
    },

    nonEmptyRoles () {
      return this.roles.filter((role) => {
        return this.users.some((user) => user.role.id === role.id);
      });
    },

    filteredRoles() {
      const count = this.users.filter((user) => user.role.id === this.user.role?.id).length;

      return this.nonEmptyRoles.filter((role) => {
        const condition = !(role.id === this.user.role?.id && count === 1);

        return condition;
      });
    },

    leadsOption() { return this.leads.option },
    leadsValue() { return this.leads.value },
    dealsOption() { return this.deals.option },
    dealsValue() { return this.deals.value },

    hasLeads() { return !!this.user.leads },
    hasDeals() { return !!this.user.deals },
  },

  watch: {
    leadsOption(newValue) {
      if (newValue === 'multiple') {
        this.leads.value = 'all';
        return;
      }

      this.leads.value = '';
    },
    dealsOption(newValue) {
      if (newValue === 'multiple') {
        this.deals.value = 'all';
        return;
      }

      this.deals.value = '';
    },
  },

  created() {
    const message = JSON.parse(localStorage.getItem('salesflow.delete-user-message'));

    if (message) {
      window.Alert.success(message);
      localStorage.removeItem('salesflow.delete-user-message');
    }
  },

  mounted() {
    Bus.$on('openModalUserDestroy', async (user) => {
      this.user = typeof user === 'string' ? JSON.parse(user) : user;

      if (this.users.length === 1) {
        this.leads.option = 'none';
        this.deals.option = 'none';

        this.removeUser();

        return;
      }

      console.log(this.user);

      if (this.hasLeads) {
        this.showUserDestroyModal();
      } else if (this.hasDeals) {
        this.showDistributeUserDealsModal();
      } else {
        this.leads.option = 'none'
        this.deals.option = 'none';

        this.removeUser();
      }
    });

    this.getRoles();
  },

  methods: {
    hideUserDestroyModal() {
      this.$refs['user-destroy-modal'].hide();
    },

    showUserDestroyModal() {
      this.$refs['user-destroy-modal'].show();
    },

    hideDistributeUserDealsModal() {
      this.$refs['distribute-user-deals-modal'].hide();
    },

    showDistributeUserDealsModal() {
      this.deals.option = 'individual';

      this.$refs['distribute-user-deals-modal'].show();
    },

    handleUserDestroyModalCompleted(event) {
      event.preventDefault();

      this.hideUserDestroyModal();

      if (this.hasDeals) {
        this.showDistributeUserDealsModal();
      } else {
        this.deals.option = 'none';

        this.removeUser();
      }
    },

    reset () {
      this.leads.option = 'none';
      this.deals.option = 'individual';
    },

    async removeUser(event) {
      if (event) {
        event.preventDefault();
      }

      if (
        this.deals.option === 'individual'
        && !this.deals.value
      ) {
        return Alert.error('Um usuário deve ser selecionado');
      }

      if (!await Confirm(this.__('Deseja excluir?'))) {
        this.reset();

        return;
      }

      const { data } = await this.$http.delete(`/user/${this.user.id}`, {
        body: {
          leads: this.leads,
          deals: this.deals,
        }
      });

      localStorage.setItem('salesflow.delete-user-message', JSON.stringify(data.message));
      location.reload();
    },

    getRoles() {
      this.$http
        .get('/role?ajax=true')
        .then((response) => {
          this.roles = response.data;
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';
@import '../../../sass/mixins';

::v-deep {
  .modal-dialog {
    max-width: 540px;
    height: 100%;
    margin: auto;
  }
}

.cancel-modal-button a {
  text-decoration: underline;
  color: $salesflow-font-gray;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 150%;

  &:hover {
    color: $salesflow-purple-dark !important;
  }
}

.btn.btn-primary {
  background-color: $salesflow-secondary;

  span {
    font-size: 1rem;
  }

  &:hover {
    background-color: $salesflow-secondary-hover;
  }
}

select {
  color: $salesflow-font-dark !important;
  font-weight: 400 !important;
  font-size: 1rem;
}

select.modal-input {
  width: 100%;
}

.modal-distribution-info {
  @include salesflow-text($color: $salesflow-font-gray, $font-weight: 500);
}

#distribute-user-deals-modal {
  select {
    &.font-gray-light {
      color: $salesflow-font-gray-light !important;
    }

    option {
      color: $salesflow-font-dark !important;
    }
  }
}

#user-destroy-modal .form-group label {
  font-weight: 700;
}

#distribute-user-deals-modal .form-group {
  .radio-input-group {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
  }

  label {
    font-weight: 700;
    color: $salesflow-font-dark;
    margin-bottom: 0px;
  }
}

#distribute-user-deals-modal {
  .h6.modal-subtitle {
    margin-top: 24px;
    margin-bottom: 24px;
  }
}

.form-wrapper {
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: baseline;
}

.h6.modal-subtitle, .modal-text-info {
  font-size: 0.75rem;
  font-weight: 500;
  color: $salesflow-font-gray;
}

input[type='radio'] {
  cursor: pointer;
  margin-right: 8px;
  position: relative;

  &::before {
    top: -2px;
    left: -2px;
    content: '';
    width: 16px;
    height: 16px;
    border-radius: 50%;
    position: absolute;
    pointer-events: none;
    background-color: #fff;
    border: 1px solid #7123db;
  }

  &:checked::after {
    top: 2px;
    left: 2px;
    width: 8px;
    height: 8px;
    content: '';
    border-radius: 50%;
    position: absolute;
    pointer-events: none;
    background-color: #7123db;
  }
}
</style>
